/**
 * SettingsRepository — reads and writes the settings table. SQL only (rule R3).
 */

import type { SqliteClient } from '../adapters/sqlite-client';

export class SettingsRepository {
  constructor(private readonly db: SqliteClient) {}

  get(key: string): string | null {
    const value = this.db.scalar<string>('SELECT value FROM settings WHERE key = ?', [key]);
    return value === null ? null : String(value);
  }

  set(key: string, value: string): void {
    this.db.run(
      `INSERT INTO settings (key, value) VALUES (?, ?)
       ON CONFLICT(key) DO UPDATE SET value = excluded.value`,
      [key, value],
    );
  }

  getBoolean(key: string, fallback: boolean): boolean {
    const raw = this.get(key);
    return raw === null ? fallback : raw === '1';
  }

  setBoolean(key: string, value: boolean): void {
    this.set(key, value ? '1' : '0');
  }
}
